import React, { useContext, useState, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import Button from '../../../components/Button';
import { BiTrash } from 'react-icons/bi';
import Modal from './extraModal/TrustedPersonsModal'


export default function TrustedPersons() {

  const { allForms, addMode, studentTabData, updateInitialValues, trackDeletion } = useContext(StudentsContext)

  const { values, setFieldValue, setValues } = allForms

  const { trusted_persons: trustedData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [selectedItem, setSelectedItem] = useState(null)

  useEffect(() => {
    const dataJson = JSON.stringify(trustedData)
    if (!addMode && trustedData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        trusted_persons: [...trustedData]
      }))
      if (updateInitialValues) {
        updateInitialValues('trusted_persons', trustedData)
      }
    }
  }, [trustedData, addMode, setValues, updateInitialValues])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const handleSaveItem = (itemData) => {
    if (selectedItem === 'add' || !itemData.id) {
      const newItem = {
        ...itemData,
        id: `new_${Date.now()}`
      }
      setFieldValue('trusted_persons', [...(values.trusted_persons || []), newItem])
    } else {
      const updated = (values.trusted_persons || []).map(item =>
        item.id === itemData.id ? itemData : item
      )
      setFieldValue('trusted_persons', updated)
    }
    setTimeout(() => allForms.handleSubmit(), 0)
    closeModal()
  }

  const handleDeleteItem = (itemId) => {
    if (!String(itemId).startsWith('new_')) {
      trackDeletion('trusted_persons', itemId)
    }
    const filtered = (values.trusted_persons || []).filter(item => item.id !== itemId)
    setFieldValue('trusted_persons', filtered)
  }

  const renderLi = (item) => {
    const { id, documentdate, fio, holidays, withoutsupport, vacation } = item
    return (
      <tr key={id} onClick={openModal(item)}>
        <td>{fio}</td>
        <td>{documentdate}</td>
        <td>{holidays ? 'Да' : 'Нет'}</td>
        <td>{vacation ? 'Да' : 'Нет'}</td>
        <td>{withoutsupport ? 'Да' : 'Нет'}</td>
        <td><i className={styles.trash} onClick={(e) => { e.stopPropagation(); handleDeleteItem(id) }}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem === 'add' ? {} : selectedItem}
          height={'430px'}
          addMode={selectedItem === 'add'}
          onSave={handleSaveItem}
          onDelete={handleDeleteItem}
        />
      }
      <div className={styles.qualificationForm}>
        <Table className={styles.table} >
          <thead>
            <tr>
              <th>Фамилия И.О.</th>
              <th>Срок действия</th>
              <th>В выходные</th>
              <th>В отпуск</th>
              <th>Без сопровождения</th>
              <th>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {values.trusted_persons?.map(renderLi)}
          </tbody>
        </Table>
        <br />
        <Button onClick={openModal('add')}>Добавить</Button>
      </div>
    </div>
  )
}

